import { Component, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { mergeMap } from 'rxjs/operators';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';
import {ArrayDataSource, DataSource} from "@angular/cdk/collections";
import {NestedTreeControl} from "@angular/cdk/tree";
import {GoogleAdsAccountNode} from "../google-ads/google-ads.component";
import {MatTreeNestedDataSource} from "@angular/material/tree";

@Component({
  selector: 'google-ads-read-only',
  templateUrl: './google-ads-read-only.component.html',
  styleUrls: ['./google-ads-read-only.component.scss']
})
export class GoogleAdsReadOnlyComponent implements OnDestroy {
  private subs = [];

  loading = false;
  saving = false;

  accounts: Array<any> = [];
  noAccounts = false;
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  oauthURL = '';
  isAdmin = false;
  customerId;
  accountLinked = false;
  useCallExt = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  emitter: EventEmitter<any>;

  googleAccountTree: Array<GoogleAdsAccountNode> = [];
  googleAccountSource: DataSource<GoogleAdsAccountNode>;
  accountTreeControl: NestedTreeControl<GoogleAdsAccountNode>;
  hasChild = (_:number, node: GoogleAdsAccountNode) => {
    return node.account.isMcc;
  }
  constructor(
    public dialogRef: MatDialogRef<GoogleAdsReadOnlyComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.existingIntegrations = this.data.existingIntegrations;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
    }
    this.emitter = this.data.emitter;
    this.accountTreeControl = new NestedTreeControl<GoogleAdsAccountNode>(
      node => node.getChildren()
    )
    this.googleAccountSource = new MatTreeNestedDataSource<GoogleAdsAccountNode>();

    // let sub = this.integrationDao.getGoogleAdsOauthUrl(this.data.brand, true).subscribe(res => {
    //   this.oauthURL = res['url'];
    // });
    // this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  doNotSubmit(e) {
    e.preventDefault();
  }

  formatCustomerId(rawId: string) {
    let customerId = rawId.substr(0, 3);
    customerId += '-';
    customerId += rawId.substr(3, 3);
    customerId += '-';
    customerId += rawId.substr(6);
    return customerId;
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  save(account) {
    this.saving = true;
    // let sub = this.integrationDao
    //   .update(this.createdIntegration.id, {
    //     customerId: this.formatCustomerId(account.customerId),
    //     loginCustomerId: account.loginCustomerId?this.formatCustomerId(account.loginCustomerId):null,
    //     accountLinked: true,
    //     enabled: true,
    //     type: 'google_ads',
    //     friendlyName: account.name
    //   })
    //   .subscribe(
    //     res => {
    //       this.createdIntegration.id = res.id;
    //       this.createdIntegration.enabled = res.enabled;
    //       this.createdIntegration.accountLinked = res.accountLinked;
    //       this.createdIntegration.friendlyName = res.friendlyName;
    //       this.saving = false;
    //       this.dialogRef.close(this.createdIntegration);
    //     },
    //     err => console.error(err)
    //   );
    // this.subs.push(sub);
  }

  done() {
    this.dialogRef.close(this.createdIntegration);
  }

  onClick(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    let opened = window.open(this.oauthURL, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'google_ads' && event.data.id !== undefined) {
          this.loading = true;
          this.noAccounts = false;
          let intSub = this.integrationDao
              .loadById(event.data.id)
              .pipe(
                  // mergeMap(res => {
                  //   this.createdIntegration = res;
                  //   //return this.integrationDao.getGoogleAdsAccounts(this.createdIntegration.id);
                  // })
              )
              .subscribe(accounts => {
                //this.googleAccountTree = accounts.map(acct => new GoogleAdsAccountNode(acct, this.createdIntegration.id, this.integrationDao));
                this.googleAccountSource = new ArrayDataSource(this.googleAccountTree);
                if (!this.googleAccountTree.length) {
                  this.noAccounts = true;
                }
                this.loading = false;
              });
          this.subs.push(intSub);

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        }
      }
    }

    window.addEventListener('message', listener);
  }
}
